<template>
  <CarouselDotIndicatorBase :on-click-scroll-to="onClickScrollTo" :selected-index="selectedIndex" :should-show-by-default="props.shouldDisplayByDefault" :total-item-count="scrollSnaps.length" />
</template>

<script setup lang="ts">
import CarouselDotIndicatorBase from '@/components/lib/shadcn-vue/carousel/CarouselDotIndicatorBase.vue';
import { useCarousel } from '@/components/lib/shadcn-vue/carousel/useCarousel';

interface Props {
  shouldDisplayByDefault?: boolean;
}

const props = defineProps<Props>();

const { scrollTo, selectedIndex, scrollSnaps } = useCarousel();

const onClickScrollTo = (e: MouseEvent, index: number) => {
  e.preventDefault();
  // カード全体がリンクの一覧では、伝播させるとカードのクリックとして遷移・計測されてしまう
  e.stopPropagation();
  scrollTo(index);
};
</script>
